import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import {
  ISurveyAnswerDTO,
  SurveyAnswerDTO,
  SurveyCustomerDetailDTO,
} from '@/../client-generator/generated-clients/surveys';
import surveyClient from '@/core/api/surveys-service';

import { Form, Rate as ElRate } from 'element-ui';

@Component({
  components: {
    ElRate,
  },
  i18n: {
    messages: {
      it: {
        addVote: 'Aggiungi un voto',
        feedbackAlreadySent: 'Hai già inviato il tuo feedback',
        writeNotes: 'Scrivi qui eventuali note',
        invalidSurvey: 'Sondaggio invalido',
        alreadyAnswered: 'Sondaggio già svolto',
        close: 'Chiudi',
      },
    },
  },
})
export default class DialogFeedback extends Vue {
  @PropSync('isDialogVisible', { type: Boolean, required: true })
  isVisible!: boolean;

  @Prop({ required: true }) surveyId!: number;
  @Prop({ required: true }) stars!: number;

  isLoading = true;
  survey: SurveyCustomerDetailDTO | null = null;

  formModel: ISurveyAnswerDTO = {
    score: 0,
    comment: '',
  };

  colors = ['#0295ce', '#0295ce', '#0295ce'];

  get isAnswered() {
    if (this.survey) {
      return this.survey.hasAlreadyAnswered;
    }

    return false;
  }

  get formRules() {
    const required = {
      required: true,
      message: this.$t('validation.fieldRequired'),
    };

    return {
      rating: required,
      text: required,
    };
  }

  mounted() {
    this.fetchSurvey();
  }

  async fetchSurvey() {
    this.isLoading = true;

    try {
      this.survey = await surveyClient.myDetail(this.surveyId);
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        case 404:
          messageError = this.$t('customerNotFound').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
      this.handleClose();
    } finally {
      this.isLoading = false;
    }
  }

  submit() {
    const $form = this.$refs.theForm as Form;

    $form.validate(async (isValid) => {
      if (isValid) this.sendFeedback();
    });
  }

  async sendFeedback() {
    this.isLoading = true;

    try {
      this.formModel.surveyId = this.surveyId;
      this.formModel.score = Number.isNaN(this.stars) ? 0 : this.stars;
      this.formModel.surveyAnswerId = this.survey?.surveyAnswerId;

      const answer = new SurveyAnswerDTO(this.formModel);
      await surveyClient.answer(answer);
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 400:
        case 404:
          messageError = this.$t('invalidSurvey').toString();
          break;
        case 401:
        case 403:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 409:
          messageError = this.$t('alreadyAnswered').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.isLoading = false;
      this.handleClose();
    }
  }

  handleClose() {
    this.isVisible = false;
  }
}
